import { getAccountId } from "@/lib/auth/account";
import { apiPost } from "@/lib/http/client";

const DEDUPE_MS = 2_000;

let lastPath: string | null = null;
let lastAt = 0;

export function resetPageVisitDedupe(): void {
  lastPath = null;
  lastAt = 0;
}

/** Same user, same page, within 2s: do not increment. */
export function shouldCountPageVisit(path: string, now = Date.now()): boolean {
  if (lastPath === path && now - lastAt < DEDUPE_MS) {
    return false;
  }
  lastPath = path;
  lastAt = now;
  return true;
}

/** Fire-and-forget page enter. Unknown paths are ignored by the API. */
export async function recordPageVisit(path: string): Promise<void> {
  if (!getAccountId()?.startsWith("acct_")) {
    return;
  }
  if (!shouldCountPageVisit(path)) {
    return;
  }
  try {
    await apiPost<null>("/page-visits", { path });
  } catch {
    /* analytics must never block the UI */
  }
}
